import { cn } from "@drpcrd/utils/shared";

type Props = {
  className: string;
};

/**
 * Loading skeleton for notification cards with avatar and content placeholders
 */
export const NotificationSkeleton = ({ className }: Props) => (
  <div
    className={cn("flex items-center gap-2 rounded-lg px-1.5 py-2", className)}
  >
    <div className="h-3 w-3 rounded-full bg-neutral-200" />
    <div className="flex flex-1 flex-col gap-0.5">
      <div className="h-2.5 w-1/2 rounded-sm bg-neutral-200" />
      <div className="h-2.5 w-3/4 rounded-sm bg-neutral-200" />
    </div>
  </div>
);
